import React from 'react'
import { Container,Row,Col,ListGroup,ListGroupItem } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './footer.css'

const Footer = () => {
    return (
        <footer className='footer'>
            <Container>
                <Row>
                    <Col lg='4' md='6' className='mb-4'>
                        <div className='logo'>
                            <div>
                                <h1 className='text-white'>ElQaNaS</h1>
                            </div>
                        </div>
                        <p className='footer__text mt-4'>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, ea. Consectetur error recusandae ipsum quos porro ratione reprehenderit maiores voluptatem, officiis ullam laborum aspernatur sint dolorum quibusdam numquam nostrum provident!
                        </p>
                    </Col>
                    <Col lg='3' md='6' className='mb-4'>
                        <div className="footer__links">
                            <h4 className="footer__links-title">
                                Top Categories
                            </h4>
                            <ListGroup className='link-group mb-3'>
                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='#'>Mobile Phones</Link>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='#'>Modern Sofa</Link>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='#'>Arm Chair</Link>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='#'>Smart Watches</Link>
                                </ListGroupItem>
                            </ListGroup>
                        </div>
                    </Col>
                    <Col lg='2' md='6' className='mb-4'>
                        <div className="footer__links">
                            <h4 className="footer__links-title">
                                Useful Links
                            </h4>
                            <ListGroup className='link-group mb-3'>
                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='/shop'>Shop</Link>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='/cart'>Cart</Link>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='/login'>Login</Link>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0'>
                                    <Link to='#'>Privacy Policy</Link>
                                </ListGroupItem>
                            </ListGroup>
                        </div>
                    </Col>
                    <Col lg='3' md='6' className='mb-4'>
                        <div className="footer__links">
                            <h4 className="footer__links-title">
                                Contact
                            </h4>
                            <ListGroup className='link-group mb-3'>
                                <ListGroupItem className='ps-0 border-0 d-flex gap-2'>
                                    <span><i className='ri-map-pin-line'></i></span>
                                    <p>Egypt,Fayoum</p>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0 d-flex gap-2'>
                                    <span><i className='ri-phone-line'></i></span>
                                    <p>+201033505324</p>
                                </ListGroupItem>

                                <ListGroupItem className='ps-0 border-0 d-flex gap-2'>
                                    <span><i className='ri-mail-line'></i></span>
                                    <p>ahmedazouz022@gmail.com</p>
                                </ListGroupItem>
                            </ListGroup>
                        </div>
                    </Col>
                    <Col lg='12'>
                        <p className="footer__copyright">CopyRight 2024 Developed by ElQaNaS . All rights reserved. </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer